import { useEffect, useState } from 'react';
import { getAllBranchesToBeConsolidated, getAllListBranchesToTransformToStaticBranches } from 'automation-ui-canvas/action-features/list-branch/branchConsolidation';
import UIAlert from 'UIComponents/alert/UIAlert';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIList from 'UIComponents/list/UIList';
import { H5 } from 'UIComponents/elements/headings';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptimizationAlert = ({
  flow,
  numOfCollapsedBranchActions
}) => {
  const [branchesToConsolidate, setBranchesToConsolidate] = useState([]);
  useEffect(() => {
    setBranchesToConsolidate(getAllBranchesToBeConsolidated(flow));
  }, [flow]);
  const [listBranchesToTransformToStaticBranches, setListBranchesToTransformToStaticBranches] = useState([]);
  useEffect(() => {
    setListBranchesToTransformToStaticBranches(getAllListBranchesToTransformToStaticBranches(flow));
  }, [flow]);
  const consolidationLine = branchesToConsolidate.length ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "automation.optimizeCanvas.alert.consolidation.plural",
    options: {
      count: numOfCollapsedBranchActions + 1,
      finalNumOfActions: branchesToConsolidate.length
    }
  }) : null;
  const transformationLine = listBranchesToTransformToStaticBranches.length ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "automation.optimizeCanvas.alert.transformation.plural",
    options: {
      count: listBranchesToTransformToStaticBranches.length
    }
  }) : null;
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "300",
    inlineSize: "600px",
    children: /*#__PURE__*/_jsxs(UIAlert, {
      type: "info",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.optimizeCanvas.alert.title"
        })
      }), /*#__PURE__*/_jsxs(UIList, {
        styled: true,
        className: "m-bottom-2",
        children: [consolidationLine, transformationLine]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "automation.optimizeCanvas.alert.description_jsx.plural",
          options: {
            count: listBranchesToTransformToStaticBranches.length + branchesToConsolidate.length,
            supportKey: SupportLinkKeys.OPTIMIZE
          },
          elements: {
            DocButton
          }
        })
      })]
    })
  });
};
export default OptimizationAlert;